$(function(){
    $('#zoom-custom').owlCarousel({
        items:1,
        loop:false,
        dots:false,
        nav:true,
        autoplay:false
    });
})